import { render, staticRenderFns } from "./tenantParticulars.vue?vue&type=template&id=68f70bd7&scoped=true&"
import script from "./tenantParticulars.vue?vue&type=script&lang=js&"
export * from "./tenantParticulars.vue?vue&type=script&lang=js&"
import style0 from "./tenantParticulars.vue?vue&type=style&index=0&id=68f70bd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f70bd7",
  null
  
)

export default component.exports